import React from 'react'

import styled from 'styled-components'

import { ContentSection, Content } from 'src/refactor/structure'
import { mediaQueries, palette } from '@centivo/react-components'
import IconSliceArrowRight from 'src/assets/Images/icons/slice-arrow-right.svg'

import src from 'src/assets/logos/centivoCare/centivo-care.svg'
import { useGlobalState } from 'src/context/global'

const ContentWrapper = styled(Content)`
  font-family: 'AnekGujarati';

  padding-top: 3rem;
  padding-bottom: 2.5rem;
  padding-horizontal: 150px;

  @media ${mediaQueries.desktop} {
    width: calc(1440px + 4rem);
    max-width: 90%;
    align-self: center;
  }

  @media ${mediaQueries.mobile} {
    padding: 0;
  }
`

const ContentContainer = styled(ContentSection)`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 2.5rem 3rem;
  padding-bottom: 2.5rem !important;
  border: 4px solid ${palette.brand.darkGreen};
  border-radius: 40px;
  background-color: #f7f4e6;
  text-align: left;
  width: 100%;

  > img {
    height: 80px;
  }

  > h2 {
    margin: 2rem 0 1.5rem;
    color: ${palette.brand.darkGreen};
    font-weight: 700;
    font-size: 2rem;
    line-height: 120%;
    line-spacing: -0.84px;
  }

  > p {
    color: ${palette.brand.darkGray};
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 140%;
  }

  > a {
    margin-top: 2.75rem;
    color: ${palette.brand.newPurple};
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 120%;
    line-spacing: -0.56px;

    > img {
      margin-left: 0.75rem;
      height: 1rem;
    }
  }

  @media ${mediaQueries.mobile} {
    border-radius: 0;
    border: none;
    padding: 2.5rem 1.25rem;

    > img {
      height: 5rem;
    }
  }
`

export const CentivoCareSection: React.FC = () => {
  const [{ appConfig }] = useGlobalState()
  const { title, body, text, link } = appConfig.centivoCare

  return (
    <ContentWrapper>
      <ContentContainer>
        <img src={src} alt="Centivo care" />
        <h2>{title}</h2>
        <p>{body}</p>
        <a rel="noopener noreferrer" target="_blank" href={link}>
          <span>{text}</span>
          <img src={IconSliceArrowRight} alt="Centivo Care" />
        </a>
      </ContentContainer>
    </ContentWrapper>
  )
}
